const AlarmType = {
  TOTAL_OUTAGE: 1,
  MISPRODUCTION: 2,
  COMMUNICATION_LOSS: 3,
  STRING_OUTAGE: 4,
  SENSOR_OUTAGE: 5,
  USER_DEFINED: 6,
  DATA_OUTAGE: 7,
  BATTERY_CHARGE_LEVEL: 8,
  TRACKER_DEVIATION: 9,
};

export default AlarmType;
